import api from '../../services/service_expend'
import Swal from 'sweetalert2'
import Multiselect from 'vue-multiselect'
import CateView from '../../components/cate_view'
import SubcateView from '../../components/subcate_view'
import Pagination from 'vue-pagination-2'
import moment from 'moment'
import vuejsDatepicker from 'vuejs-datepicker'
import SearchSubExpen from '../../views/search_expensub'
import {
  th
} from 'vuejs-datepicker/dist/locale'

export default {
  components: {
    Multiselect,
    CateView,
    SubcateView,
    Pagination,
    vuejsDatepicker,
    SearchSubExpen
  },
  data() {
    return {
      now_date: this.dateFormatDMY2(new Date()),
      search: '',
      exp_list: {
        pagination: []
      },
      header: {
        headers: {
          'access-token': this.$store.state.token
        }
      },
      activePage: 1,
      allItem: 0,
      ItemPerpage: 10,
      th: th
    }
  },
  methods: {
    callback: function (page) {
      this.activePage = page
      this.getExp()
    },
    getExp() {
      this.$store.state.isLoading = true

      var body = {
        search: this.search,
        date: this.now_date,
        active_page: this.activePage,
        per_page: this.ItemPerpage
      }
      api.getExpenAll(
        body,
        this.header,
        result => {
          if (result.response === true) {
            this.exp_list = result.data
            this.allItem = result.data.count
          } else {
            Swal.fire('ดึงข้อมูลหมวดหมู่', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    remove(id) {
      Swal.fire({
        title: 'ลบข้อมูลรายจ่าย',
        text: 'ท่านต้องการลบข้อมูลรายจ่ายนี้ ใช่หรือไม่ ?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.$store.state.isLoading = true
          api.delExpen(
            id,
            this.header,
            result => {
              if (result.response === true) {
                this.getExp()
                this.alert_msg('success', 'ลบข้อมูลรายจ่าย', result.data)
              } else {
                Swal.fire('ดึงข้อมูลผู้ใช้งาน', result.message, 'warning')
              }
              this.$store.state.isLoading = false
            },
            error => {
              alert(JSON.stringify(error))
              this.$store.state.isLoading = false
            }
          )
        }
      })
    }
  },
  beforeMount() {
    if (this.$route.query.page == 'undefined') {
      this.$router.push('/manageexp')
    }
    this.search = this.$route.query.search ? this.$route.query.search : this.search
    this.now_date = this.$route.query.filterdate ? this.$route.query.filterdate : this.now_date
    this.activePage = this.$route.query.page ? parseInt(this.$route.query.page) : this.activePage
  },
  mounted() {
    this.getExp()
    $('input').on('change', function () {
      this.setAttribute(
        'data-date',
        moment(this.value, 'YYYY-MM-DD')
        .format(this.getAttribute('data-date-format'))
      )
    }).trigger('change')
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/manage_expenditure.js